<form [formGroup]="form" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>
			{{ label.length > 0 ? label : 'Select Item' + (isMultiple ? '(s)' : '') }}
		</mat-label>

		<mat-select formControlName="select" [multiple]="isMultiple">

			<div class="padding-md text-center row gx-0">
				<div class="col" *ngIf="isMultiple">
					<button type="button" color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
				</div>

				<div class="col text-center">
					<button type="button" color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect <span *ngIf="isMultiple">All</span>
					</button>
				</div>
			</div>

			<mat-option *ngFor="let obj of objects | keyvalue" [value]="obj.value">
				{{ display(obj.value) }}
			</mat-option>

		</mat-select>
	</mat-form-field>
</form>